import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import ConfirmPopup from '@components/ConfirmPopup'

import { ShortlistModalsProps } from './types'

export const ShortlistConfirmModals = ({
  deleteShortlist,
  removeAlertProfiles,
  removeProfiles,
  exitShortlist,
}: ShortlistModalsProps) => {
  const { t } = useTranslation()
  return (
    <>
      {deleteShortlist.isVisible && (
        <ConfirmPopup
          id="shortlist-confirm-delete-shortlist"
          isOpen
          width={260}
          title={t(translationKeys.DELETE_A_CUSTOM_LIST)}
          text={t(translationKeys.ARE_YOU_SURE_TO_DELETE_A_CUSTOM_LIST)}
          cancelBtnText={t(translationKeys.CUSTOM_LIST_POPUP_CANCEL_BTN)}
          confirmBtnText={t(translationKeys.DELETE_CUSTOM_LIST)}
          onCancel={deleteShortlist.onCancel}
          onConfirm={deleteShortlist.onConfirm}
        />
      )}
      {removeAlertProfiles.isVisible && (
        <ConfirmPopup
          id="shortlist-confirm-remove-alerts-from-profiles"
          isOpen
          width={225}
          title={removeAlertProfiles.title ?? ''}
          text={removeAlertProfiles.text ?? ''}
          cancelBtnText={t(translationKeys.CUSTOM_LIST_POPUP_CANCEL_BTN)}
          confirmBtnText={t(translationKeys.REMOVE)}
          onCancel={removeAlertProfiles.onCancel}
          onConfirm={removeAlertProfiles.onConfirm}
        />
      )}
      {removeProfiles.isVisible && (
        <ConfirmPopup
          id="shortlist-confirm-permanently-delete-profile-shortlist"
          isOpen
          width={225}
          title={t(translationKeys.DELETE_ITEMS)}
          text={t(translationKeys.DO_YO_WANT_PERMANENTLY_DELETE)}
          cancelBtnText={t(translationKeys.CUSTOM_LIST_POPUP_CANCEL_BTN)}
          confirmBtnText={t(translationKeys.CUSTOM_LIST_POPUP_CONFIRM_BTN)}
          onCancel={removeProfiles.onCancel}
          onConfirm={removeProfiles.onConfirm}
        />
      )}
      {exitShortlist.isVisible && (
        <ConfirmPopup
          id="shortlist-page-confirm-exit-popup"
          width={294}
          contentWidth={180}
          isOpen
          title={t(translationKeys.UNSAVED_SETTINGS)}
          text={t(translationKeys.YOU_HAVENOT_SAVED_CHANGES)}
          cancelBtnText={t(translationKeys.CONTINUE_EDITING)}
          confirmBtnText={t(translationKeys.CLOSE_ANYWAY)}
          onCancel={exitShortlist.onCancel}
          onConfirm={exitShortlist.onConfirm}
        />
      )}
    </>
  )
}
